<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let value = 1;
    export let minValue = 0;

    const dispatch = createEventDispatcher();

    const plusValue = () => {
        value++;
        dispatch('change');
    }

    const minusValue = () => {
        if (value > minValue) {
            value--;
            dispatch('change');
        }
    }

    const onChange = (event) => {
        if (value == '' || value < minValue) {
            value = minValue;
        }
    }
</script>

<div class="input-group number-spinner">
    <button class="btn btn-default" on:click="{ minusValue }">-</button>
    <input type="text" class="form-control text-center" bind:value="{ value }"
    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
           on:change={ onChange }
    >
    <button class="btn btn-default" on:click="{ plusValue }">+</button>
</div>

<style>
    .number-spinner .btn {
        width: 35px;
        padding-left: 0;
        padding-right: 0;
    }
</style>